import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';



function PieTwoToneIcon(props) {
  return (
    <SvgIcon {...props} viewBox="-4 -4 24 24">
<path opacity="0.25" d="M8.439,8.591L8.223,0.724c0,0,1.778-2.781,6.277,2.776c4.25,5.25-0.53,9.901-0.53,9.901L8.439,8.591z"/>
<path d="M0,8.501C0,3.807,3.807,0,8.501,0l0,0C13.193,0,17,3.807,17,8.501l0,0C17,13.194,13.193,17,8.501,17l0,0
	C3.807,17,0,13.194,0,8.501L0,8.501z M0.936,8.501c0.008,4.178,3.387,7.559,7.565,7.565l0,0c4.178-0.007,7.558-3.388,7.566-7.565
	l0,0c-0.009-4.178-3.389-7.558-7.566-7.566l0,0C4.322,0.943,0.943,4.323,0.936,8.501L0.936,8.501z"/>
<line  x1="8.355" y1="8.998" x2="8.355" y2="0.352"/>
<line  x1="8.238" y1="8.297" x2="15.483" y2="11.219"/>
<path d="M8.625,0.5C4.276,0.5,0.75,4.025,0.75,8.375s3.526,7.875,7.875,7.875"/>
<path d="M1.551,5.41c-1.888,3.918-0.241,8.626,3.678,10.512c3.918,1.888,8.625-0.759,10.512-4.678"/>
    </SvgIcon>
  );
}

export default PieTwoToneIcon;


